// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useQueryWithOffset } from '@hooks/other/useQueryWithOffset';
import { UseQueryResult } from '@tanstack/react-query';
import { ProviderConfiguration } from '@daml.js/utility-registry-app-v0/lib/Utility/Registry/App/V0/Configuration/Provider';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';
import { useParties } from '../../../../contexts/PartiesContext';
import TemplateContract from '../../../../utils/TemplateContract';

const useRegistryProviderConfigurations: () => UseQueryResult<
  TemplateContract<ProviderConfiguration>[],
  string
> = () => {
  const ledgerApi = useLedgerApiClient();
  const { operator } = useParties();
  return useQueryWithOffset({
    queryKey: ['queryRegistryProviderConfigurations', operator],
    enabled: !!operator,
    queryFn: async (_, offset) => {
      return ledgerApi.queryRegistryProviderConfigurations(offset, operator);
    },
  });
};

export default useRegistryProviderConfigurations;
